import React, { useEffect, useState } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { Recorder } from "../components/stream/Recorder";
import Webcam from "react-webcam";
import { useStreamProvider } from "../api/StreamProvider";

export function HomeTest() {

  const webcamRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [capturing, setCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [streamDimensions, setStreamDimensions] = useState({ width: 0, height: 0 });
  const [webcamActive, setWebcamActive] = useState(true)

  const { 
    closeCurrentStreams, 
    streamVideoWidthRef, 
    streamVideoHeightRef, 
    streamVideoOriginal,
    setStreamVideoOriginal,
} = useStreamProvider()

  const videoConstraints = {
    width: { ideal: 1920 },
    height: { ideal: 1080 },
    facingMode: "user"
  };

  useEffect(() => {
    if (webcamRef.current) {
      console.log("🚀 ~ HomeTest ~ webcamRef:", webcamRef)
      setStreamVideoOriginal(webcamRef.current.stream)
    }
  }, [webcamRef.current])


  function handleStartCaptureClick() {
    setCapturing(true);
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: "video/webm"
    });
    mediaRecorderRef.current.addEventListener("dataavailable", ({ data }) => {
      if (data.size > 0) {
        console.log('event.data.size: ', data.size);
        setRecordedChunks((prev) => prev.concat(data));
      }
    });
    mediaRecorderRef.current.start();
  }

    const handleDataAvailable = React.useCallback(
      ({ data }) => {
        if (data.size > 0) {
          console.log('event.data.size: ', data.size)
          setRecordedChunks((prev) => prev.concat(data));
        }
      },
      [setRecordedChunks]
    );

    const handleStopCaptureClick = React.useCallback(() => {
      mediaRecorderRef.current.stop();
      setCapturing(false);
    }, [mediaRecorderRef, webcamRef, setCapturing]);

    const handleDownload = React.useCallback(() => {
      if (recordedChunks.length) {
        const blob = new Blob(recordedChunks, {
          type: "video/webm"
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = "react-webcam-stream-capture.webm";
        a.click();
        window.URL.revokeObjectURL(url);
        setRecordedChunks([]);
      }
    }, [recordedChunks]);


    function parseUserAgent(userAgentString) {
      const result = {
        browser: null,
        browserVersion: null,
        os: null,
        mobile: false,
      };
    
      // Detectar el navegador y su versión
      if (userAgentString.includes("Chrome")) {
        result.browser = "Chrome";
        const match = userAgentString.match(/Chrome\/([0-9.]+)/);
        if (match) {
          result.browserVersion = match[1];
        }
      } else if (userAgentString.includes("Firefox")) {
        result.browser = "Firefox";
        const match = userAgentString.match(/Firefox\/([0-9.]+)/);
        if (match) {
          result.browserVersion = match[1];
        }
      } // Añade más condiciones según sea necesario
    
      // Detectar el sistema operativo
      if (userAgentString.includes("Windows")) {
        result.os = "Windows";
      } else if (userAgentString.includes("Macintosh")) {
        result.os = "macOS";
      } else if (userAgentString.includes("Android")) {
        result.os = "Android";
        result.mobile = true;
      } else if (userAgentString.includes("iPhone") || userAgentString.includes("iPad")) {
        result.os = "iOS";
        result.mobile = true;
      } // Añade más condiciones según sea necesario
    
      // Detectar si es móvil (general)
      if (userAgentString.includes("Mobile")) {
        result.mobile = true;
      }
    
      return result;
    }


  useEffect(() => {
    console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: init")
    if (webcamRef.current) {
      const stream = webcamRef.current?.stream;
      console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: here")
      if (stream) {
        console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: stream")
        const videoTracks = stream.getVideoTracks();
        if (videoTracks.length > 0) {
          const settings = videoTracks[0].getSettings();
          console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: settings : ", settings)
          console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: navigator : ", parseUserAgent(navigator.userAgent))
          // Verifica si las dimensiones han cambiado
          if (settings.width !== streamDimensions.width || settings.height !== streamDimensions.height) {
            console.log("🚀 ~ HomeTest ~ [webcamRef.current?.stream: update : ", settings)
            // Actualiza el estado con las nuevas dimensiones
            setStreamDimensions({ width: settings.width, height: settings.height });
            // Carga nuevamente el stream original
            setStreamVideoOriginal(stream);
          }
        }
      }
    }
  }, [webcamRef.current?.stream]); // Dependencia: stream de video


    const handleLoadStream = () =>{
      console.log("🚀 ~ HomeTest ~ webcamRef:", webcamRef)
      setStreamVideoOriginal(webcamRef.current.stream)
    }

    // Paso 1: Definir un array de resoluciones comunes a probar
    const commonResolutions = [
      { width: 320, height: 240 },
      { width: 480, height: 360 },
      { width: 640, height: 480 },
      { width: 800, height: 600 },
      { width: 1024, height: 768 },
      { width: 1280, height: 720 },
      { width: 1280, height: 800 },
      { width: 1280, height: 1024 },
      { width: 1366, height: 768 },
      { width: 1440, height: 900 },
      { width: 1600, height: 900 },
      { width: 1920, height: 1080 },
      { width: 2048, height: 1080 },
      { width: 2560, height: 1440 },
      { width: 3840, height: 2160 },
      // Añadir más resoluciones según sea necesario
      // Resoluciones comunes de iPhone
      { width: 640, height: 1136 }, // iPhone 5
      { width: 750, height: 1334 }, // iPhone 6, 6s, 7, 8
      { width: 1242, height: 2208 }, // iPhone 6 Plus, 6s Plus, 7 Plus, 8 Plus
      { width: 1125, height: 2436 }, // iPhone X, XS
      { width: 828, height: 1792 }, // iPhone XR, 11
      { width: 1242, height: 2688 }, // iPhone XS Max, 11 Pro Max
      { width: 1170, height: 2532 }, // iPhone 12, 12 Pro
      { width: 1284, height: 2778 }, // iPhone 12 Pro Max
      // Resoluciones comunes de Android (ejemplos genéricos, pueden variar)
      { width: 720, height: 1280 }, // HD
      { width: 1080, height: 1920 }, // Full HD
      { width: 1440, height: 2560 }, // QHD
      { width: 1080, height: 2340 }, // 19.5:9 aspect ratio
      { width: 1440, height: 2960 }, // QHD+ in 18.5:9 aspect ratio
    ];

// Paso 2: Crear la función testResolutions
const testResolutions = async () => {
  for (let resolution of commonResolutions) {
    const constraints = {
      video: {
        width: { exact: resolution.width },
        height: { exact: resolution.height }
      }
    };

    try {
      // Paso 4: Usar getUserMedia para probar la resolución
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      // Obtener el track de video
      const videoTrack = stream.getVideoTracks()[0];
      // Obtener las configuraciones actuales del track
      const settings = videoTrack.getSettings();

      // Verificar si las dimensiones del video coinciden con las solicitadas
      if (settings.width === resolution.width && settings.height === resolution.height) {
        console.log(`Resolución soportada: ${resolution.width}x${resolution.height}`);
      } else {
        console.log(`Resolución reportada como soportada, pero no coincide al probar: ${resolution.width}x${resolution.height}`);
      }
    } catch (error) {
      console.log(`Resolución no soportada: ${resolution.width}x${resolution.height}`);
    }
  }
};

const toggleWebcam = () => {

  if (webcamActive) {
    setStreamDimensions({ width: 0, height: 0 })
    
  }else{
    setStreamVideoOriginal(null)
  }

  setWebcamActive(!webcamActive)
  
}







  return (
    <HomeWrapper>

    {webcamActive && (
      <>
        <Webcam 
          videoConstraints={videoConstraints} 
          width={0}
          height={0}
          audio={false} 
          ref={webcamRef} 
          screenshotQuality={1}
        />

        {capturing ? (
          <button onClick={handleStopCaptureClick}>Stop Capture</button>
        ) : (
          <button onClick={handleStartCaptureClick}>Start Capture</button>
        )}
        {recordedChunks.length > 0 && (
          <button onClick={handleDownload}>Download</button>
        )}

        <Recorder action_send={null}/>
        <button onClick={handleLoadStream}>LoadStream</button>
        <button onClick={testResolutions}>Test Resolutions</button>
      </>
    )}
      
      <button onClick={toggleWebcam}> Stop webcam </button>
      
    </HomeWrapper>
  );

}


